import { getComposeStore } from 'owa-calendar-compose-store-manager';

// Returns the user identity for which the event is being created/udpated
export default function getCurrentEventUserIdentity(): string {
    return getComposeStore().event && getComposeStore().event.ParentFolderId
        ? getComposeStore().event.ParentFolderId.mailboxInfo.userIdentity
        : null;
}
